import { FieldType } from '@cxbox-ui/schema'
import { CustomFieldTypes } from '@interfaces/widget'

export const checkboxFilterFieldTypes = [FieldType.dictionary, CustomFieldTypes.MultipleSelect, FieldType.radio]
